// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import LazyImage, { LazyImageProps } from "@guestsupply/MobiusOverrides/LazyImage";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Clickable, Hidden } from "@insite/mobius/index";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {}

export interface BrandDetailsLogoStyles {
    container?: InjectableCss;
    image?: LazyImageProps;
    heading?: TypographyProps;
}

export const logoStyles: BrandDetailsLogoStyles = {};

const styles = logoStyles;

const BrandDetailsLogo: FC<Props> = () => {
    const { value: brand } = useContext(BrandStateContext);

    if (!brand) {
        return null;
    }
    const isInternalUrl = brand.properties.largeLogoImagePath?.includes("guestsupply");

    return (
        <StyledWrapper {...styles.container} data-test-selector="brandLogo">
            {
                // XNG-Changes: make the brand image clickable if it has a url
                brand.properties.largeLogoImagePath ? (
                    <Clickable href={brand.properties.largeLogoImagePath} target={isInternalUrl ? "_self" : "_blank"}>
                        <LazyImage
                            width="1920"
                            height="400"
                            src={brand.logoLargeImagePath}
                            altText={brand.logoAltText}
                            {...styles.image}
                            customTransformations={{ default: "GUEST_Brand_1920x400" }}
                        />
                    </Clickable>
                ) : (
                    <LazyImage
                        width="1920"
                        height="400"
                        src={brand.logoLargeImagePath}
                        altText={brand.logoAltText}
                        {...styles.image}
                        customTransformations={{ default: "GUEST_Brand_1920x400" }}
                    />
                )
            }
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsLogo,
    definition: {
        group: "Brand Details",
        icon: "diamond",
        displayName: "Brand Logo",
        allowedContexts: ["BrandDetailsPage"],
    },
};

export default widgetModule;
